import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row, Button } from "reactstrap";

const Breadcrumbs = (props) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {/* <span color="primary" onClick={() => navigate(-1)} className="me-3">
                &#8592; Back
              </span> */}
              <h4 className="mb-0 font-size-18">{props.breadcrumbItem}</h4>
            </div>
            <div className="page-title-right">
              <Breadcrumb listClassName="m-0">
                <BreadcrumbItem>
                  <Link to="#">{props.title}</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  {props.breadcrumbItem}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Breadcrumbs;
